export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}
